var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import StatementsContextProvider from "../context/statementsContext";
import DefaultProviders from "../ui/DefaultProviders";
import StatementsModal from "../ui/templates/StatementsModal";
var StatementsRoot = function (_a) {
    var config = _a.config, selectedAccountId = _a.selectedAccountId, isModalOpen = _a.isModalOpen, containerId = _a.containerId, handleClose = _a.handleClose, handleProfileClick = _a.handleProfileClick, handleRequestPastStatementsClick = _a.handleRequestPastStatementsClick;
    var statementGlobalState = {
        accountId: selectedAccountId,
        isModalOpen: isModalOpen,
        showEnrollmentError: false,
        isMutationLoading: false,
    };
    return (_jsx(DefaultProviders, __assign({ config: config }, { children: _jsx(StatementsContextProvider, __assign({ initialState: statementGlobalState, handleClose: handleClose, handleProfileClick: handleProfileClick, handleRequestPastStatementsClick: handleRequestPastStatementsClick }, { children: _jsx(StatementsModal, { containerId: containerId }) })) })));
};
export default StatementsRoot;
